export const state = {
  karTypeSelected1: '',
  karTypeSelected2: '',
  karTypeSelected3: '',
  karTypeSelected4: '',
  karTypeSelected5: '',
  karTypeSelected6: '',
  costKarniz1: null,
  costKarniz2: null,
  costKarniz3: null,
  costKarniz4: null,
  costKarniz5: null,
  costKarniz6: null
}

export const getters = {

}

export const mutations = {
  updateKarniz1 (state, karTypeSelected1) {
    state.karTypeSelected1 = karTypeSelected1
  },
  updateKarniz2 (state, karTypeSelected2) {
    state.karTypeSelected2 = karTypeSelected2
  },
  updateKarniz3 (state, karTypeSelected3) {
    state.karTypeSelected3 = karTypeSelected3
  },
  updateKarniz4 (state, karTypeSelected4) {
    state.karTypeSelected4 = karTypeSelected4
  },
  updateKarniz5 (state, karTypeSelected5) {
    state.karTypeSelected5 = karTypeSelected5
  },
  updateKarniz6 (state, karTypeSelected6) {
    state.karTypeSelected6 = karTypeSelected6
  },
  updateCostKarniz1 (state) {
    if (state.karTypeSelected1 === 'Нет') {
      state.costKarniz1 = null
    } else if (state.karTypeSelected1 === 'Шина потолочная') {
      state.costKarniz1 = 1890
    } else if (state.karTypeSelected1 === 'Настенный карниз') {
      state.costKarniz1 = 3290
    } else {
      state.costKarniz1 = null
    }
  },
  updateCostStep5Karniz1 (state) {
    if (this.state.Window1.widthWindow1 >= 2500) {
      state.costKarniz1 = state.costKarniz1 + (state.costKarniz1 * 0.35)
    }
  },
  updateCostStep5Karniz1WithErker (state) {
    if (this.state.Window1.windowTypeSelected1 === 'Эркерное окно') {
      state.costKarniz1 = state.costKarniz1 + (state.costKarniz1 * 0.35)
    }
  },
  // 2 окно
  updateCostKarniz2 (state) {
    if (state.karTypeSelected2 === 'Нет') {
      state.costKarniz2 = null
    } else if (state.karTypeSelected2 === 'Шина потолочная') {
      state.costKarniz2 = 1890
    } else if (state.karTypeSelected2 === 'Настенный карниз') {
      state.costKarniz2 = 3290
    } else {
      state.costKarniz2 = null
    }
  },
  updateCostStep5Karniz2 (state) {
    if (this.state.Window2.widthWindow2 >= 2500) {
      state.costKarniz2 = state.costKarniz2 + (state.costKarniz2 * 0.35)
    }
  },
  updateCostStep5Karniz2WithErker (state) {
    if (this.state.Window2.windowTypeSelected2 === 'Эркерное окно') {
      state.costKarniz2 = state.costKarniz2 + (state.costKarniz2 * 0.35)
    }
  },
  // 3 окно
  updateCostKarniz3 (state) {
    if (state.karTypeSelected3 === 'Нет') {
      state.costKarniz3 = null
    } else if (state.karTypeSelected3 === 'Шина потолочная') {
      state.costKarniz3 = 1890
    } else if (state.karTypeSelected3 === 'Настенный карниз') {
      state.costKarniz3 = 3290
    } else {
      state.costKarniz3 = null
    }
  },
  updateCostStep5Karniz3 (state) {
    if (this.state.Window3.widthWindow3 >= 2500) {
      state.costKarniz3 = state.costKarniz3 + (state.costKarniz3 * 0.35)
    }
  },
  updateCostStep5Karniz3WithErker (state) {
    if (this.state.Window3.windowTypeSelected3 === 'Эркерное окно') {
      state.costKarniz3 = state.costKarniz3 + (state.costKarniz3 * 0.35)
    }
  },
  // 4 окно
  updateCostKarniz4 (state) {
    if (state.karTypeSelected4 === 'Нет') {
      state.costKarniz4 = null
    } else if (state.karTypeSelected4 === 'Шина потолочная') {
      state.costKarniz4 = 1890
    } else if (state.karTypeSelected4 === 'Настенный карниз') {
      state.costKarniz4 = 3290
    } else {
      state.costKarniz4 = null
    }
  },
  updateCostStep5Karniz4 (state) {
    if (this.state.Window4.widthWindow4 >= 2500) {
      state.costKarniz4 = state.costKarniz4 + (state.costKarniz4 * 0.35)
    }
  },
  updateCostStep5Karniz4WithErker (state) {
    if (this.state.Window4.windowTypeSelected4 === 'Эркерное окно') {
      state.costKarniz4 = state.costKarniz4 + (state.costKarniz4 * 0.35)
    }
  },
  // 5 окно
  updateCostKarniz5 (state) {
    if (state.karTypeSelected5 === 'Нет') {
      state.costKarniz5 = null
    } else if (state.karTypeSelected5 === 'Шина потолочная') {
      state.costKarniz5 = 1890
    } else if (state.karTypeSelected5 === 'Настенный карниз') {
      state.costKarniz5 = 3290
    } else {
      state.costKarniz5 = null
    }
  },
  updateCostStep5Karniz5 (state) {
    if (this.state.Window5.widthWindow5 >= 2500) {
      state.costKarniz5 = state.costKarniz5 + (state.costKarniz5 * 0.35)
    }
  },
  updateCostStep5Karniz5WithErker (state) {
    if (this.state.Window5.windowTypeSelected5 === 'Эркерное окно') {
      state.costKarniz5 = state.costKarniz5 + (state.costKarniz5 * 0.35)
    }
  },
  // 6 окно
  updateCostKarniz6 (state) {
    if (state.karTypeSelected6 === 'Нет') {
      state.costKarniz6 = null
    } else if (state.karTypeSelected6 === 'Шина потолочная') {
      state.costKarniz6 = 1890
    } else if (state.karTypeSelected6 === 'Настенный карниз') {
      state.costKarniz6 = 3290
    } else {
      state.costKarniz6 = null
    }
  },
  updateCostStep5Karniz6 (state) {
    if (this.state.Window6.widthWindow6 >= 2500) {
      state.costKarniz6 = state.costKarniz6 + (state.costKarniz6 * 0.35)
    }
  },
  updateCostStep5Karniz6WithErker (state) {
    if (this.state.Window6.windowTypeSelected6 === 'Эркерное окно') {
      state.costKarniz6 = state.costKarniz6 + (state.costKarniz6 * 0.35)
    }
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
